module.exports = __webpack_public_path__ + "static/vtf_hngl-webfont-e5852084f3195aba453a5cb0839bb4fd.svg";